import { trackSearchResultEvent } from "@insite/client-framework/Common/Utilities/tracking";
import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface SurViewReturnsModel {
    searchparameter: StoreParameter;
    viewdata: any;
    uri: string;
    viewReturnList: ViewReturns[];
    pagination: ViewReturnPagination;
    properties: Properties2;
}

export interface ViewReturns {
    uri: string;
    rmaNumber: string;
    rmaDate: string;
    status: string;
    webRMAId: string;
    totalCreditAmount: number;
    properties: Properties;
    totalCreditAmountDisplay:string;
}

export interface Properties {}

export interface ViewReturnPagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOption[];
    sortType: string;
    nextPageUri: string;
    prevPageUri: string;
}

export interface SortOption {
    displayName: string;
    sortType: string;
}

export interface Properties2 {}

export interface ViewReturnsResultModel {}

export interface ViewReturnsParameter extends ApiParameter {
    invoiceNumber?: string;
    rmaDate?: string;
    rmaNumber?: string;
    beginDate?: string | null;
    pageSize?: number;
    isLoad?: boolean;
    sort?: string;
    endDate?: string | null;
    page?: number;
}

const ViewReturnsUrl = "/api/v2/returns";
export interface StoreParameter {
    rmaNumber?: string;
    invoiceNumber?: string;
    rmaDate?: string;
    beginDate?: string;
    pageSize?: number;
    endDate?: string;
    sort?: string;
}

export async function getViewReturn(
    parameter: ViewReturnsParameter & HasOnSuccess<ViewReturnsResultModel> & HasOnComplete<ViewReturnsResultModel>,
) {
    const response = await get<SurViewReturnsModel>(ViewReturnsUrl, parameter);
    return response;
}
